import { graphql } from '@/lib/query'

const OfficeFragment = graphql(/* GraphQL */ `
  fragment OfficeFragment on OfficeRecord @_unmask {
    position
    businessType
    title
    id
    googleDirectionsLink
    address
    telephone
    email
    openings {
      title
      content
    }
  }
`)

export default OfficeFragment
